import React, { useState } from 'react'
import { Button, Modal, Typography } from 'antd'
import styled from 'styled-components';
import { injected, walletconnect } from '../connectors'
import MetaMaskIcon from '../images/metamask.png';
import WalletConnectIcon from '../images/walletConnectIcon.svg';
import { useActiveWeb3React } from '../hooks/web3';
import { getEllipsisTxt } from '../helpers/formatters'
import { useMediaQuery } from 'react-responsive'
import { isMobile } from '../utils/userAgent'
import '../style/wallet-modal.css'

declare let window: any;

interface Props {

}
const { Text } = Typography
const styles = {
    button: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "27px",
        letterSpacing: '0.58px',
        fontSize: "13.5px",
        borderRadius: "10px",
        background: 'rgba(159, 11, 49)',
        color: '#ffffff',
        fontFamily: 'KozGoPr6N-Heavy',
    },
    iconWrapper: {
        alignItems: "center",
        justifyContent: "center",
    }
}
const Box = styled('div')`
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding: 16px;
    background-color: rgb(44, 47, 54); 
    color: #fff;
    font-family: KozGoPr6N-Medium;
    :hover {
        cursor: pointer;
    }
`
const Account = (props: Props) => {
    const { activate, account } = useActiveWeb3React()
    const [isModalOpen, setModalOpen] = useState(false);
    const isTablet = useMediaQuery({
        query: '(min-width: 992px)'
    })
    if (account) {
        return (
            <div>
                <Button style={{ ...styles.button, border: (isTablet ? "none" : "") }}>{getEllipsisTxt(account)}</Button>
            </div>
        )
    }
    return (
        <div>
            <Button style={{ ...styles.button, border: (isTablet ? "none" : "") }} onClick={() => { setModalOpen(true) }}>CONNECT WALLET</Button>
            <Modal
                title="Connect Wallet"
                visible={isModalOpen}
                wrapClassName="wallet-modal"
                footer={null}
                onCancel={() => { setModalOpen(false) }}
                bodyStyle={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '16px'
                }}>
                {
                    window.ethereum ?
                        <Box onClick={() => {
                            activate(injected, undefined, true)
                                .catch(err => { console.log(err) })
                                .finally(() => { setModalOpen(false) })
                        }}>
                            <Text style={{ color: '#fff' }}>Metamask</Text>
                            <div style={styles.iconWrapper}>
                                <img src={MetaMaskIcon} alt="Icon" height="24px" width="24px" />
                            </div>
                        </Box>
                        :
                        (isMobile ?
                            <a href="https://metamask.app.link/dapp/" target="_blank" rel="noreferrer">
                                <Box>
                                    <Text style={{ color: '#fff' }}>Install or Open Metamask</Text>
                                    <div style={styles.iconWrapper}>
                                        <img src={MetaMaskIcon} alt="Icon" height="24px" width="24px" />
                                    </div>
                                </Box>
                            </a> :
                            <a href="https://metamask.io" target="_blank" rel="noreferrer">
                                <Box>
                                    <Text style={{ color: '#fff' }}>Install Metamask</Text>
                                    <div style={styles.iconWrapper}>
                                        <img src={MetaMaskIcon} alt="Icon" height="24px" width="24px" />
                                    </div>
                                </Box>
                            </a>
                        )
                }
                <Box onClick={() => {
                    activate(walletconnect, undefined, true)
                        .catch(err => { console.log(err) })
                        .finally(() => { setModalOpen(false) })
                }}>
                    <Text style={{ color: '#fff' }}>WalletConnect</Text>
                    <div style={styles.iconWrapper}>
                        <img src={WalletConnectIcon} alt="Icon" height="24px" width="24px" />
                    </div>
                </Box>
            </Modal>
        </div >
    )
}

export default Account
